<template>
      <div  class="ccpay-temlogin">
    <article class="nav-title" v-show="!this.$flag">
      <mt-header title="用户登录">
               <!-- <a href="javascript:void(0);" slot="left" @click='goBack'>
                    <mt-button icon="back"></mt-button>
                </a> -->
            </mt-header>
        </article>
        <img src="../../../../static/img/back.png" style="visibility:hidden;" class='gu_nav_title_img_top'
            v-show='this.$flag' @click='goBack'>
        <div class="mobile_content pl-40 pr-40">
            <div class="email_content">
                <h3 class="">
                    <br>OTC919承兑商平台
                </h3>
                <form action="">
          <mt-field
            class="phoneNum phoneNumTull-lv"
            placeholder="邮箱"
            type="text"
            v-model="phone"
                    ></mt-field>
                    <!-- <div class='phoneError' ref='phone'></div> -->
                    <mt-field class="passInputWord"  placeholder="密码"  v-model="password"
                       type="password"
                    > </mt-field>
                    <!-- <div class='passwordError' ref='password'></div> -->
                    <!-- <p class="c9 fz15 mt-15">
                        <a href="javascript:void(0)" class="c9 " @click='goPhoneForgetPasswordOne'>找回密码</a>
                        <a href="javascript:void(0)" class="fr c4a5" @click='goPhoneRegisterOne'>手机注册</a>
                    </p> -->
                    <mt-button class="mt-40" size="large" type="primary" @click.prevent="temlogin"
                        style='letterSpacing:5px;padding-right:0.2rem' >登录</mt-button>
                    <!-- <mt-button class="mt-20" size="large" type="default" @click.prevent="goPhoneCaptchaLogin">手机验证码登录</mt-button> -->
          <mt-button
            class="mt-20"
            size="large"
            type="default"
            @click.prevent="goReg"
            >注册</mt-button
          >
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Indicator } from 'mint-ui';
import {mapActions,mapState} from 'vuex'
// import {getCookie} from '../../../public/index'
// import {setElpCookie} from '../../../public/index'

import {setCookie,setElpCookie,ccpayUser,getCookie,Formatnumbers} from '../../../public/index.js'
export default {
    name:'phonelogin',
    data() {
        return {
            phone:'',
            password:'',
        }
    },
    mounted(){
        if(this.$route.query.type){
                setElpCookie('elptoken','',-1,'')
                setCookie('ccpay-token','',-1)
                ccpayUser('',-1)
                this.$Toast('请您重新登录')
        }
        // this.removeHtml()
    },
    computed :{
        ...mapState({
            //检测手机号的返回值
            // phoneHaveData:state=>state.phoneStore.phoneHaveData
        })
    },
    methods: {
        setCookie,
        getCookie,
        setElpCookie,
        // ...mapActions({
        //     getPhoneHaveAction:'phoneStore/getPhoneHaveAction',//检测手机号是否存在
        //     getPhoneLoginAction:'phoneStore/getPhoneLoginAction',//手机登录
        //     getUserInfoAction:'phoneStore/getUserInfoAction'//用户个人信息
        // }),
        goBack () {
            // let url =window.localStorage.getItem('url')
            // this.$router.push({
            //     path:url
            // })
        },
        //先触发清空input值的事件
        removeHtml() {
            document.getElementsByClassName('mint-field-clear')[0].addEventListener('click',(event)=>{
                phoneVerification('',this.$refs.phone)
            }),
            document.getElementsByClassName('mint-field-clear')[1].addEventListener('click',(event)=>{
                passwordVerification('',this.$refs.password)
            })
        },
    goReg() {
      //let _that = this;
      // setTimeout(function () {
        // _that.$Toast("注册功能异常，请稍后再试");
      // }, 800);
      //console.log(_that.$router)
      //_that.$router.push({
      //  path: "/regAccount",
      //});
      // return;

      window.location.href='https://www.otc919.com/cn/signup';
    },
        temlogin(){
            if(this.phone==''){
                 this.$Toast('用户不存在或密码错误')
                 return
            }
            if(this.password==''){
                 this.$Toast('用户不存在或密码错误')
                 return
            }
             Indicator.open();
            this.$axios.post('/v1/login/loginV2S1',{
                 "account": this.phone,
                 "password": this.password,
                 "country_code": "+86"}).then(res=>{
                     Indicator.close();
                    if(res.code==400){
                        this.$Toast('用户不存在或密码错误')
                        return
                    }
                    if(res.code==0){
                         window.localStorage.setItem('elptoken-phone',this.phone)
                         window.localStorage.setItem('elptoken-password',this.password)
                        setElpCookie('elptoken',res.data.token,10,res.data.codeType)
                        this.$router.push({
                            path:'/Login'
                        })
                    }else{
                        this.$Toast(res.msg)
                        return
                    }
            })
            // console.log(1)
        },
        auto(){

        }
        // //手机按键事件
        // phoneInput () {
        //     if(this.$refs.phone.innerHTML!=''){
        //         this.$refs.phone.innerHTML='',
        //         this.$refs.phone.style.borderTop='none'
        //     }
        // },
        // //密码按键事件
        // passwordInput () {
        //     if(this.$refs.password.innerHTML!=''){
        //         this.$refs.password.innerHTML='',
        //         this.$refs.password.style.borderTop='none'
        //     }
        // },
    },
    components:{
    }
}
</script>
<style lang='scss' scoped>
.ccpay-temlogin{
    height: 100%;
    background: white;
}
.email_content{
    margin-top:4.5rem;
}
.email_content h3{
    margin-bottom:3rem;
}
.email_content form .phoneNum {
}
.mint-cell-value{
    width: 10rem
}
</style>





// WEBPACK FOOTER //
// src/components/login/phone/phoneLogin.vue